import { Icon } from "@/components/ui/icon";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import {
  SeoGlobalSettingsTab,
  SeoPageTypeDefaultsTab,
  SeoOverridesTab,
  SeoHealthChecksTab,
} from "./seo";

export const SeoManager = () => {
  const [advancedOpen, setAdvancedOpen] = useState(false);
  const [healthOpen, setHealthOpen] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 text-muted-foreground">
        <Icon name="search" size={20} />
        <p className="text-sm">
          Manage SEO settings, meta tags, and social sharing
        </p>
      </div>

      {/* Primary Section: Global Settings */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <Icon name="settings" size={20} />
          Global Settings
        </h3>
        <SeoGlobalSettingsTab />
      </div>

      {/* Advanced Section: Page Types & Overrides */}
      <Collapsible open={advancedOpen} onOpenChange={setAdvancedOpen}>
        <CollapsibleTrigger asChild>
          <Button 
            variant="ghost" 
            className="w-full justify-between p-4 h-auto border border-border rounded-lg hover:bg-muted/50"
          >
            <span className="flex items-center gap-2 font-semibold">
              <Icon name="tune" size={20} />
              Advanced Settings
            </span>
            <Icon 
              name={advancedOpen ? "expand_less" : "expand_more"} 
              size={20} 
              className="text-muted-foreground"
            />
          </Button>
        </CollapsibleTrigger>
        <CollapsibleContent className="pt-4 space-y-6">
          {/* Page Type Defaults */}
          <div className="space-y-4 border-l-2 border-muted pl-4">
            <h4 className="text-md font-medium flex items-center gap-2">
              <Icon name="category" size={18} />
              Page Type Defaults
            </h4>
            <p className="text-sm text-muted-foreground">
              Set default SEO patterns for different page types (useful when you add more pages)
            </p>
            <SeoPageTypeDefaultsTab />
          </div>

          {/* Overrides */}
          <div className="space-y-4 border-l-2 border-muted pl-4">
            <h4 className="text-md font-medium flex items-center gap-2">
              <Icon name="edit" size={18} />
              Page Overrides
            </h4>
            <p className="text-sm text-muted-foreground">
              Override SEO settings for specific pages (auto-populates from project data)
            </p>
            <SeoOverridesTab />
          </div>
        </CollapsibleContent>
      </Collapsible>

      {/* Health Checks Section */}
      <Collapsible open={healthOpen} onOpenChange={setHealthOpen}>
        <CollapsibleTrigger asChild>
          <Button 
            variant="ghost" 
            className="w-full justify-between p-4 h-auto border border-border rounded-lg hover:bg-muted/50"
          >
            <span className="flex items-center gap-2 font-semibold">
              <Icon name="health_and_safety" size={20} />
              SEO Health Checks
            </span>
            <Icon 
              name={healthOpen ? "expand_less" : "expand_more"} 
              size={20} 
              className="text-muted-foreground"
            />
          </Button>
        </CollapsibleTrigger>
        <CollapsibleContent className="pt-4">
          <SeoHealthChecksTab />
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

export default SeoManager;
